import DOMPurify from "dompurify";
import { marked } from "marked";

const ALLOWED_TAGS = [
  "p",
  "br",
  "strong",
  "em",
  "del",
  "blockquote",
  "ul",
  "ol",
  "li",
  "h2",
  "h3",
  "h4",
  "pre",
  "code",
  "a",
  "table",
  "thead",
  "tbody",
  "tr",
  "th",
  "td",
  "hr",
];

const ALLOWED_ATTR = ["href", "title", "target", "rel"];

export function safeHttpUrl(
  href: string | null | undefined,
): string | undefined {
  if (!href) return undefined;

  try {
    const url = new URL(
      href,
      typeof window === "undefined"
        ? "https://widget.invalid"
        : window.location.origin,
    );
    if (url.protocol !== "http:" && url.protocol !== "https:") {
      return undefined;
    }
    return url.href;
  } catch {
    return undefined;
  }
}

export function renderSafeMarkdown(markdown: string): string {
  const source = typeof markdown === "string" ? markdown.slice(0, 200_000) : "";
  const parsed = marked.parse(source, {
    async: false,
    breaks: true,
    gfm: true,
  }) as string;

  const sanitized = DOMPurify.sanitize(parsed, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    FORBID_TAGS: [
      "script",
      "style",
      "iframe",
      "object",
      "embed",
      "svg",
      "math",
      "form",
      "input",
      "button",
      "img",
      "video",
      "audio",
    ],
    FORBID_ATTR: ["style", "src", "srcset"],
    ALLOW_DATA_ATTR: false,
    ALLOW_ARIA_ATTR: false,
  });

  const template = document.createElement("template");
  template.innerHTML = sanitized;

  for (const anchor of template.content.querySelectorAll("a")) {
    const safeUrl = safeHttpUrl(anchor.getAttribute("href"));
    if (!safeUrl) {
      anchor.replaceWith(document.createTextNode(anchor.textContent ?? ""));
      continue;
    }
    anchor.href = safeUrl;
    anchor.target = "_blank";
    anchor.rel = "noopener noreferrer";
  }

  return template.innerHTML;
}
